import { useContext, useEffect, useState } from 'react';

import axios from 'axios';
import { sendGTMEvent } from 'helpers/google-tag-manager';
import { MIXPANEL_EVENTS } from 'pages/leads/constants';
import useLeadsMixPanel from 'pages/leads/hooks/use-leads-mixpanel';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useAsyncFn } from 'react-use';

import { Alert, Box, Text } from '@olist/united';

import { API_URLS } from '../../../constants';
import { RootContext } from '../../leads-provider';
import SegmentsForm from '../segments-form/segments-form';
import { Wrapper } from './segments-container.style';

const SegmentsContainer = () => {
  const { t } = useTranslation();

  const { appUrls, leadProfileCookie, setLeadCategoryStorage, setLeadTotalFields } =
    useContext(RootContext);
  const routeHistory = useHistory();

  const mixpanelInstance = useLeadsMixPanel();

  const [isUnqualifiedLead, setIsUnqualifiedLead] = useState(false);

  const [chosenCategory, setChosenCategory] = useState(null);
  const [
    { error: hasRequestError, loading: isSubmittingForm, value: requestData },
    submitQualification,
  ] = useAsyncFn(
    async (segments) => {
      const postValues = {
        categories: segments,
      };

      setLeadTotalFields(segments.length);
      setLeadCategoryStorage(segments ?? segments.shift());

      return axios.post(API_URLS.getCategories, postValues);
    },
    [leadProfileCookie]
  );

  useEffect(() => {
    if (hasRequestError && chosenCategory) {
      setChosenCategory(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasRequestError]);

  useEffect(() => {
    sendGTMEvent('page_view', {
      user_id: leadProfileCookie?.email,
    });
  }, [leadProfileCookie]);

  useEffect(() => {
    const handleRedirectAfterSubmit = () => {
      if (!requestData) return;

      const { data } = requestData;

      if (data.isQualified) {
        if (data?.redirectTo?.match(/shop-windows/i)) {
          mixpanelInstance?.track('Experiment Shop Windows', {
            'Variant Name': 'Viwed experiment page',
          });
        } else {
          mixpanelInstance?.track('Experiment Shop Windows', {
            'Variant Name': 'Redirected to current flow',
          });
        }

        window.location.href = data.redirectTo || appUrls.REVENUES_URL;
        return;
      }

      setIsUnqualifiedLead(true);
    };

    handleRedirectAfterSubmit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appUrls.CREATE_PASSWORD_URL, requestData, routeHistory]);

  const handleSubmit = (segments) => {
    const segmentsAsText = segments.join(', ');

    setChosenCategory(segmentsAsText);
    mixpanelInstance?.track(MIXPANEL_EVENTS.ANSWERED_CATEGORIES, { category: segmentsAsText });
    submitQualification(segments).then(() => {
      sendGTMEvent('etapa_cadastro', {
        etapa: 'categorias',
      });
    });
  };

  return (
    <Wrapper width={[1, 1, 1, '628px']}>
      {hasRequestError && (
        <Alert mb={3} messages={[t`ops, the form could not be submitted. Try again`]} />
      )}
      <Box maxWidth="628px">
        <Text fontSize={['19px', '31px']} mt={2} fontWeight="bold">
          {t`what is the main category of your products?`}
        </Text>
        <Box mt={5}>
          <SegmentsForm
            onAnswer={handleSubmit}
            isSubmittingForm={isSubmittingForm}
            isUnqualifiedLead={isUnqualifiedLead}
            setIsUnqualifiedLead={setIsUnqualifiedLead}
          />
        </Box>
      </Box>
    </Wrapper>
  );
};

export default SegmentsContainer;
